/**
 * Separator component with Dashboard3 styling
 * 
 * Horizontal and vertical separators for dividing content.
 * 
 * @example
 * ```tsx
 * <Separator />
 * <Separator orientation="vertical" h="40px" />
 * ```
 */

import { Box, type BoxProps } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

export interface SeparatorProps extends Omit<BoxProps, "orientation"> {
  /**
   * Separator orientation
   */
  orientation?: "horizontal" | "vertical";
}

export const Separator = ({
  orientation = "horizontal",
  ...props
}: SeparatorProps) => {
  const theme = useThemeTokens();

  if (orientation === "vertical") {
    return (
      <Box
        w="1px"
        bg={theme.borderGlass.default}
        {...props}
      />
    );
  }

  return (
    <Box
      h="1px"
      w="100%"
      bg={theme.borderGlass.default}
      {...props}
    />
  );
};

